import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { isPC } from 'constants/layout';
import { ZIndex } from 'constants/zIndex';

export const TableWrapper = styled.div`
  flex-grow: 1;
  position: relative;
  z-index: ${ZIndex.ForStackingContext};
`;

export const TableContainer = styled.div`
  overflow: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const Table = styled.table`
  position: relative;
  border-collapse: separate;
  border-spacing: 0;
  border: 0;
  width: 100%;
  min-width: ${1680 - 192}px;
  padding-bottom: 100px;
`;

export const Thead = styled.thead(
  ({ showShadow = false }: { showShadow?: boolean }) => css`
    height: 53px;
    border-bottom: 1px solid ${Color.Gray200};
    background-color: ${Color.White};
    padding: 0;

    position: sticky;
    top: 0;
    z-index: ${ZIndex.TableThead};

    ${showShadow &&
    css`
      box-shadow: 6px 6px 6px rgba(0, 0, 0, 0.03);
      border-bottom: 1px solid ${Color.Gray200};
    `};
  `,
);

export const PinnedTh = styled.th(
  ({
    showShadow = false,
    minWidth = 50,
    width,
    textAlign = 'center',
  }: {
    showShadow?: boolean;
    minWidth?: number;
    width?: string;
    textAlign?: 'left' | 'center';
  }) => css`
    height: 53px;
    border-bottom: 1px solid ${Color.Gray200};
    background-color: ${Color.White};
    min-width: ${minWidth}px;
    ${width &&
    css`
      width: ${width};
    `}
    padding: 0;

    position: sticky;
    top: 0;
    z-index: ${ZIndex.TablePinnedTh};

    color: ${Color.Gray700};
    ${Typography.XXSmall};
    font-weight: ${FontWeight.Regular};
    text-align: ${textAlign};

    @media (${isPC}) {
      left: 0;
      z-index: ${ZIndex.TablePinnedThPc};

      ${showShadow &&
      css`
        border-right: 1px solid ${Color.Gray200};
      `}
    }
  `,
);

export const Th = styled.th(
  ({
    minWidth = 50,
    width,
    textAlign = 'center',
  }: {
    minWidth?: number;
    width?: string;
    textAlign?: 'left' | 'center';
  }) => css`
    height: 53px;
    border-bottom: 1px solid ${Color.Gray200};
    background-color: ${Color.White};
    min-width: ${minWidth}px;
    ${width &&
    css`
      width: ${width};
    `}
    padding: 0;

    position: sticky;
    top: 0;

    z-index: ${ZIndex.TableTh};

    color: ${Color.Gray700};
    ${Typography.XXSmall};
    font-weight: ${FontWeight.Regular};
    text-align: ${textAlign};
  `,
);

export const Tbody = styled.tbody``;

export const Tr = styled.tr`
  background-color: ${Color.White};
  position: relative;
  ${Typography.XXSmall};
  font-weight: ${FontWeight.Regular};

  &:hover th,
  &:hover td {
    background-color: ${Color.Gray100};
  }
`;

export const ThInTBody = styled.th(
  ({ isPinned = false }: { isPinned?: boolean }) => css`
    border-bottom: 1px solid ${Color.Gray200};
    background-color: ${Color.White};
    padding: 0;

    color: ${Color.Black};
    ${Typography.XXSmall};
    font-weight: ${FontWeight.Regular};

    @media (${isPC}) {
      position: sticky;
      left: 0;
      z-index: ${ZIndex.TableThInTBody};

      ${isPinned &&
      css`
        border-right: 1px solid ${Color.Gray200};
      `};
    }
  `,
);

export const Td = styled.td`
  background-color: ${Color.White};
  border-bottom: 1px solid ${Color.Gray200};

  color: ${Color.Black};
  ${Typography.XXSmall};
  font-weight: ${FontWeight.Regular};
`;
